<template>
  <BaseCommonPage>
    <!-- メインイメージ ジャンボトロン-->
    <CreatePlusJumbotron/>
    <!-- / メインイメージ ジャンボトロン -->

    <!-- カテゴリー一覧 -->
    <CreatePlusCategory/>
    <!-- カテゴリー一覧 -->

  </BaseCommonPage>
</template>

<script>
import CreatePlusJumbotron from '../components/CreatePlusJumbotron'
import CreatePlusCategory from '../components/CreatePlusCategory'
import BaseCommonPage from "./BaseCommonPage";
export default {
  name: "CreatePlusTop",
  props: {
  },
  components: {
    CreatePlusJumbotron,CreatePlusCategory,BaseCommonPage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  metaInfo() {
    return {
      title: "Epson Setup Navi",
      meta: [
        {
          name: "description",
          content: this.$store.state.messages.messages["0-141"],
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            process.env.VUE_APP_ROOT + "/assets/createplus/css/createplus.css",
        },
        {
          rel: "stylesheet",
          href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>